import { Dispatch, SetStateAction, useState } from 'react';
import { usePrevious } from './UsePrevious';

export const useFilterBox = (): FilterBoxType => {
  const [searchText, setSearchText] = useState<string>('');
  const previousSearchText = usePrevious<string>(searchText);

  return {
    searchText,
    previousSearchText,
    setSearchText,
  };
};

export type FilterBoxType = {
  searchText: string;
  previousSearchText: string;
  setSearchText: Dispatch<SetStateAction<string>>;
};
